<template>
  <div class="footer container-fluid">
    <div class="widthSet">
      <!-- <div class="logo">
      <img src="@/assets/img/logo_white.png" alt="logo图">
    </div> -->
      <div class="main_html">
        <h3>友情链接</h3>
        <div class="line"></div>
        <ul class="list cursorPointer">
          <li><a href="https://www.sport.gov.cn/" target="_blank">国家体育总局</a></li>
          <li><a href="https://www.lnsports.gov.cn/" target="_blank">辽宁省体育局</a></li>
          <li><a href="http://tyj.shenyang.gov.cn/" target="_blank">沈阳市体育局</a></li>
        </ul>
      </div>
      <!-- <p class="address_tel_fax">
      <span>地址：公司地址公司地址公司地址公司地址</span>
      <span>Tel：888-888-888</span>
      <span>Fax：8888-88888888</span>
    </p>
    <p class="email_wx">
      <span>邮箱：liyunkun_11@163.com</span>
      <span>公司微信号：ilyk_gg</span>
    </p> -->
      <div class="last">
        <!-- <div><a  href="javascript:void(0)">Copyright &copy; 2021-2031 沈阳市跳绳协会 版权所有</a></div> -->
        <div>
          Copyright &copy; 2021-2031 沈阳市跳绳协会 版权所有
          <span class="divider">|</span>
          <a href="javascript:void(0)" class="disclaimer-link" @click="openDisclaimer">免责声明</a>
        </div>
        <div>
          <a href="https://beian.miit.gov.cn/" target="_blank"
            >沈阳市跳绳协会 辽ICP备15019503号</a
          >
        </div>
        <!-- <div><a  href="javascript:void(0)">沈阳市跳绳协会 辽iCP备案2021015395号-1  技术支持：沈阳众弈教育信息咨询有限公司</a></div> -->
      </div>
    </div>

    <!-- 免责声明模态框（内容由运营后台配置，过长可滚动） -->
    <el-dialog
      title="免责声明"
      :visible.sync="disclaimerVisible"
      width="600px"
      append-to-body
      custom-class="disclaimer-dialog"
    >
      <div
        class="disclaimer-content"
        v-loading="disclaimerLoading"
        v-html="disclaimerContent"
      ></div>
      <div class="disclaimer-empty" v-if="!disclaimerLoading && !disclaimerContent">
        暂无内容
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="disclaimerVisible = false">我已阅读</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import '../assets/css/base.css';
import request from '../utils/request';
export default {
  name: "Footer",
  data () {
    return {
      disclaimerVisible: false,
      disclaimerContent: '',
      disclaimerLoading: false,
      disclaimerLoaded: false
    };
  },
  methods: {
    // 打开免责声明弹窗（内容首次打开时获取，之后复用）
    openDisclaimer () {
      this.disclaimerVisible = true;
      if (!this.disclaimerLoaded) {
        this.fetchDisclaimer();
      }
    },
    async fetchDisclaimer () {
      this.disclaimerLoading = true;
      try {
        const { data } = await request({
          method: 'get',
          url: '/pub/disclaimer'
        });
        this.disclaimerContent = (data.code === 200 && data.data) ? data.data : '';
        this.disclaimerLoaded = true;
      } catch (e) {
        this.disclaimerContent = '';
      }
      this.disclaimerLoading = false;
    }
  }
};
</script>
<style lang="less" scoped>
.footer {
  width: 100%;
  // height: 258px;
  font-size: 20px;
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.widthSet {
  width: 100%;
  max-width: 1440px;
}

.main_html {
  padding-top: 20px;
}

.main_html h3 {
  font-size: 24px;
  color: #dfdfdf;
  margin-top: 10px;
  margin-bottom: 10px;
}

.main_html .line {
  width: 40px;
  height: 4px;
  background: var(--ts-accent);
  border-radius: 5px;
  margin: 0 auto;
}

.list {
  /* 颜色未生效 */
  color: #cbcbcb;
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.list li {
  margin-right: 60px;
}

.list li {
  margin-right: 60px;
}
.list li:last-child {
  margin-right: 0px;
}
.list li a {
  color: #cbcbcb;
  text-decoration: none;
}
.list li a:hover {
  color: var(--ts-accent);
}

.last {
  margin-top: 20px;
  margin-bottom: 25px;
}

.last div {
  /* 颜色未生效 */
  color: #abaaaa;
}

.last div a {
  color: #abaaaa;
  text-decoration: none;
}

.last div a:hover {
  // text-decoration: underline;
  cursor: pointer;
}

/* 免责声明链接（与页脚其他链接样式一致） */
.last .disclaimer-link {
  color: #abaaaa;

  &:hover {
    color: var(--ts-accent);
  }
}

.last .divider {
  margin: 0 8px;
  color: #777;
}

/* 免责声明弹窗（内容过长时滚动） */
.disclaimer-dialog .disclaimer-content {
  max-height: 420px;
  overflow-y: auto;
  line-height: 1.8;
  font-size: 14px;
  color: #555;
  word-break: break-word;
  padding-right: 6px;

  /deep/ img {
    max-width: 100%;
    height: auto;
  }

  /deep/ table {
    border-collapse: collapse;
    width: 100%;
    margin: 10px 0;

    td, th {
      border: 1px solid #dcdfe6;
      padding: 6px 10px;
    }
  }

  /deep/ ul, /deep/ ol {
    padding-left: 24px;
  }

  /deep/ p {
    margin: 6px 0;
  }
}

.disclaimer-dialog .disclaimer-empty {
  text-align: center;
  color: #bbb;
  font-size: 14px;
  padding: 30px 0;
}

/* ============ 移动端页脚 ============ */
@media (max-width: 768px) {
  .footer {
    font-size: 14px;
    padding: 20px 12px 24px;
  }

  .list {
    flex-direction: column;
    gap: 12px;
  }

  .list li {
    margin-right: 0;
  }

  .last {
    margin-top: 14px;
  }

  .last div {
    font-size: 12px;
  }
}
</style>

<style lang="less">
/* 免责声明弹窗移动端适配（append-to-body 挂载在 body 下，需全局样式） */
@media (max-width: 768px) {
  .disclaimer-dialog {
    width: 92% !important;

    .el-dialog__body {
      padding: 12px 16px;
    }
  }
}
</style>
